import React, { useState } from 'react';
import MetaThreadDisplay from './MetaThreadDisplay';
import './MetaThreads.css';

const MetaThreads = ({ user }) => {
  const [threadsUrl, setThreadsUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [threadData, setThreadData] = useState(null);
  const [error, setError] = useState('');

  const extractWebId = (url) => {
    // Extract web ID from URLs like: https://www.threads.com/@username/post/DM3tYenhbWt
    const match = url.match(/\/post\/([A-Za-z0-9_-]+)/);
    return match ? match[1] : null;
  };

  const fetchThreadData = async (webId) => {
    try {
      const response = await fetch(`https://threads-by-meta-threads-an-instagram-app-detailed.p.rapidapi.com/get_post_with_web_id?web_id=${webId}`, {
        method: 'GET',
        headers: {
          'x-rapidapi-host': 'threads-by-meta-threads-an-instagram-app-detailed.p.rapidapi.com',
          'x-rapidapi-key': 'f19b211e36mshfabd091da7acf38p1b5a0bjsnd61130e74178'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching thread data:', error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!threadsUrl.trim()) {
      setError('Please enter a Threads URL');
      return;
    }

    const webId = extractWebId(threadsUrl);
    if (!webId) {
      setError('Invalid Threads URL. Please use a URL like: https://www.threads.com/@username/post/DM3tYenhbWt');
      return;
    }

    setLoading(true);
    setError('');
    setThreadData(null);

    try {
      const data = await fetchThreadData(webId);
      setThreadData(data);
    } catch (error) {
      setError('Failed to fetch thread data. Please check the URL and try again.');
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="meta-threads-container">
      <div className="meta-threads-header">
        <h1>Meta Threads Viewer</h1>
        <p>Paste a Threads URL to view the thread information</p>
      </div>

      <div className="meta-threads-form-section">
        <form onSubmit={handleSubmit} className="threads-url-form">
          <div className="form-group">
            <label htmlFor="threadsUrl">Threads URL:</label>
            <input
              type="url"
              id="threadsUrl"
              value={threadsUrl}
              onChange={(e) => setThreadsUrl(e.target.value)}
              placeholder="https://www.threads.com/@username/post/DM3tYenhbWt"
              className="threads-url-input"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="fetch-thread-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loading-spinner"></span>
                Fetching Thread...
              </>
            ) : (
              'Get Thread Info'
            )}
          </button>
        </form>

        {error && (
          <div className="error-message">
            <span className="error-icon">⚠️</span>
            {error}
          </div>
        )}
      </div>

      {threadData && (
        <>
          {/* Authentic Thread Display */}
          <div className="meta-thread-display-wrapper">
            <MetaThreadDisplay threadData={threadData} />
          </div>
          
          {/* Technical Information */}
          <div className="thread-data-section">
            <div className="thread-header">
              <h2>Thread Information</h2>
              <div className="thread-id">
                Web ID: <code>{threadData.post?.code}</code>
              </div>
            </div>

            <div className="thread-content">
              <div className="thread-stats">
                <div className="stat-item">
                  <span className="stat-label">Likes:</span>
                  <span className="stat-value">{threadData.post?.like_count || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Replies:</span>
                  <span className="stat-value">{threadData.post?.text_post_app_info?.direct_reply_count || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Media Type:</span>
                  <span className="stat-value">{threadData.post?.media_type || 'Unknown'}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Post ID:</span>
                  <span className="stat-value">{threadData.post?.id || 'Unknown'}</span>
                </div>
              </div>

              <div className="raw-data-section">
                <details>
                  <summary>View Raw API Response</summary>
                  <pre className="raw-data">
                    {JSON.stringify(threadData, null, 2)}
                  </pre>
                </details>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MetaThreads; 